import React from "react";
import "./PriceAndPayment.css";
import blurPrice from "../../assets/imgs/blurPrice.jpg";

export default function PriceAndPayment() {
  return (
    <div className="pricMn" id="price">
      <div className="maxW">

        <h2 className="secTtl">Price & Payments</h2>

        <div className="imgWrap">
          <img src={blurPrice} alt="Price & Payment" />
        </div>

        <div className="bottomText">
          <h3>Arvind Plots Vadodara Price List</h3>
          <h3>Arvind Plots Vadodara Payment Plan</h3>
        </div>
      </div>
    </div>
  );
}
